import React, { Component, Fragment } from 'react';
import { Container, Row, Col, Input, Label, Progress, Button } from 'reactstrap';
import { Redirect, Link } from 'react-router-dom';
import { HubConnectionBuilder } from '@aspnet/signalr';
import { getProgress, getProgressColorFor } from '../Shared/SharedUILogic';
import { API, AUTH_ERROR } from '../../Logic/API';
import { Storage } from '../../Logic/Storage';
import { TASK_GROUP_ID, GROUP_ID, RESULT_GAME_ID, RESULT_GROUP_ID } from '../../Logic/storageKeys';
import './Game.css';
import '../Spacing.css';

export class PlayTasks extends Component {
    constructor(props) {
        super(props);

        let taskGroupId = Storage.getValue(TASK_GROUP_ID);
        this.state = {
            taskGroupId,
            rangeOfTasks: [],
            isLoading: true,
            gameInfo: {},
            values: {},
            remainingDuration: 0,
            hubStarted: false,
            doNotListen:false
        }

        this.props.showHostingNav(false);
    }

    loadGame(callback) {
        API.get('/gameplay/game')
            .then(resp => resp.json())
            .then(data => {
                this.setState({
                    gameInfo: data
                }, () => {
                    this.loadTasks();
                    callback();
                });
            })
            .catch(e => {
                if (e.message === AUTH_ERROR) {
                    this.props.history.push('/play/join');
                }
            });
    }

    getQuery(includeGroup) {
        let query = `?taskgroup=${this.state.taskGroupId}&round=${this.state.gameInfo.Round}`;
        if (includeGroup) {
            let groupId = Storage.getValue(GROUP_ID);
            query += `&group=${groupId}`;
        }
        return query;
    }

    loadTasks() {
        this.setState({ isLoading: true });
        let query = this.getQuery();
        API.get(`/gameplay/tasks${query}`)
            .then(resp => resp.json())
            .then(data => {
                this.loadValues(v => {
                    this.setState({
                        values: v,
                        rangeOfTasks: data,
                        isLoading: false
                    });
                });
            })
            .catch(e => {

            });
    }

    loadValues(callback) {
        let query = this.getQuery(true);
        API.get(`/gameplay/values${query}`)
            .then(resp => resp.json())
            .then(data => {
                let v = this.toValues(data);
                callback(v);
            })
            .catch(e => {

            });
    }

    componentDidMount() {
        const hubConnection = new HubConnectionBuilder().withUrl("/hubs/gameplay").build();
        this.setState({ gameplayHub: hubConnection },
            () => {
                let onStarted = this.state.gameplayHub.start();
                this.loadGame(() => {
                    onStarted.then(() => {
                        this.setState({ hubStarted: true },
                            () => {
                                this.listenTo(this.state.gameInfo);
                            });
                    });
                });
                this.registerCallbacksOn(this.state.gameplayHub);
            });
    }

    registerCallbacksOn(hub) {
        hub.on('GameProgressUpdate',
            update => {
                if (update.GameId !== this.state.gameInfo.GameId) {
                    return;
                }
                this.setState({
                    remainingDuration: update.Remaining
                });
            });
        hub.on('GameSessionUpdate',
            update => {
                if (update.GameId !== this.state.gameInfo.GameId) {
                    return;
                }
                if (update.ClearValues) {
                    this.setState({
                        values: {}
                    });
                }
            });
        hub.on('GameRoundUpdate',
            update => {
                if (update.GameId !== this.state.gameInfo.GameId) {
                    return;
                }
                this.setState({
                    gameInfo: update,
                }, () => {
                    this.handleState();
                });
            });
    }

    handleState() {
        if (this.isGameStopped()) {
            this.setState({ remainingDuration: 0 });
        }
        if (this.isGameStarted()) {
            this.loadTasks();
        }
    }

    componentWillUnmount() {
        this.setState({ doNotListen: true });
        this.stopListeningTo(this.state.gameInfo);
    }

    listenTo(gameInfo) {
        if (this.state.doNotListen) {
            return;
        }
        if (!gameInfo.GameId) {
            console.log(`Game not loaded: ${gameInfo.GameId}`);
            return;
        }
        this.state.gameplayHub.invoke('Register', gameInfo.GameId);
    }

    stopListeningTo(gameInfo) {
        if (!this.state.hubStarted) {
            return;
        }
        if (!gameInfo.GameId) {
            return;
        }
        try {
            this.state.gameplayHub.invoke('Unregister', gameInfo.GameId);
        }
        catch(e) {

        }
    }

    isGameStarted() {
        return this.state.gameInfo.State === "Started";
    }

    isGamePaused() {
        return this.state.gameInfo.State === "Paused";
    }

    isGameCompleted() {
        return this.state.gameInfo.State && this.state.gameInfo.State === "Completed";
    }

    isGameStopped() {
        return this.state.gameInfo.State === "Stopped";
    }

    getProperty(task, i) {
        return this.getPropertyById(task.Id, i);
    }

    getPropertyById(id, i) {
        return `${id}_${i}`;
    }

    toValues(data) {
        let values = {};
        if (!data || data.length < 1) {
            return values;
        }
        data.forEach(v => {
            let property = this.getPropertyById(v.TaskId, v.Order);
            values[property] = v;
        });
        return values;
    }

    valueChanged(task, i, value) {
        let v = parseInt(value,10);
        let dto = {
            'TaskId' : task.Id,
            'Round' : this.state.gameInfo.Round,
            'Order' : i,
            'Value' : v
        };
        let property = this.getProperty(task, i);
        let newValues = { ...this.state.values };
        newValues[property] = dto;
        this.setState({ values: newValues });
    }

    getValue(task, i) {
        let property = this.getProperty(task, i);
        let value = this.state.values[property];
        if (!value) {
            return "";
        }
        return value.Value;
    }

    hasValue(task, i) {
        let property = this.getProperty(task, i);
        let value = this.state.values[property];
        return value && !isNaN(value.Value) && value.Value >= 0;
    }

    updateValue(task, i) {
        let property = this.getProperty(task, i);
        if (!this.state.values[property]) {
            return;
        }
        var dto = this.state.values[property];
        API.post('/gameplay/value', dto)
            .then(resp => resp.json())
            .then(data => {
                this.setState({});
            })
            .catch(e => {

            });
    }

    renderElement(element) {
        return (
            <Row>
                <Col className="hidden-md"></Col>
                <Col lg="6"><div className="space-top space-bottom">{element}</div></Col>
                <Col className="hidden-md"></Col>
            </Row>
        );
    }

    renderLoadingMessage() {
        return this.renderElement(
            <p className='text-lg-center'><em>Lade Aufgaben...</em></p>
        );
    }

    toTaskId(task) {
        if (!task.Process) {
            return "";
        }
        let id = `(${task.Process}`;
        if (task.Step) {
            id += ` - ${task.Step}`;
        }
        return id + ')';
    }

    renderTasks(tasks) {
        return (
            <Fragment>
                {tasks.map(task =>
                    <Fragment key={task.Id}>
                        <Row >
                            <Col className="hidden-md"></Col>
                            <Col lg="6"><p className="text-md-left">{this.toTaskId(task)} {task.Task}</p></Col>
                            <Col className="hidden-md"></Col>
                        </Row>
                        <Row>
                            <Col className="hidden-md" lg="3"></Col>
                            {[...Array(task.NumberOfValues)].map((a, i) =>
                                <Col key={this.getProperty(task, i)}>
                                    {this.renderLabel(task, i)}
                                    <Input className={"space-bottom " + (this.hasValue(task, i) ? "task-valid-border" : "")}
                                        type="number"
                                        min="0"
                                        placeholder={i + 1}
                                        value={this.getValue(task, i)}
                                        onChange={e => this.valueChanged(task, i, e.target.value)}
                                        onBlur={() => this.updateValue(task, i)} valid={this.hasValue(task, i)}
                                        disabled={!this.state.isLoading && !this.state.gameInfo.AllowValues} />
                                </Col>
                            )}
                            <Col className="hidden-md" lg="3"></Col>
                        </Row>
                    </Fragment>
                )}
            </Fragment>
        );
    }

    renderLabel(task, i) {
        if (!task.Labels) {
            return;
        }
        return (<Label style={{fontSize : '12px'}}>{task.Labels[i.toString()]}</Label>);
    }

    renderRangeOfTasks(rangeOfTasks) {
        return (
            <Fragment>
                {rangeOfTasks.map(range => 
                    <Fragment key={range.Label}>
                        <Row>
                            <Col className="hidden-md"></Col>
                            <Col lg="6"><p className="text-md-left font-weight-bold">{range.Label}</p></Col>
                            <Col className="hidden-md"></Col>
                        </Row>
                        {this.renderTasks(range.Tasks)}
                    </Fragment>
                )}
            </Fragment>
            );
    }

    render() {
        if (this.isGameCompleted()) {
            Storage.setSessionValue(RESULT_GAME_ID, this.state.gameInfo.GameId);
            let groupId = Storage.getValue(GROUP_ID);
            Storage.setSessionValue(RESULT_GROUP_ID, groupId);
            return (<Redirect to='/results/game' />);
        }
        let tasks = this.state.isLoading
            ? this.renderLoadingMessage()
            : this.renderRangeOfTasks(this.state.rangeOfTasks);

        let progress = getProgress(this.state.remainingDuration, this.state.gameInfo.DurationOfCurrentRound);

        return (
            <Container>
                <Row className="fixed-top space-beneath-header" style={{pointerEvents: 'none'}}>
                    <Col>
                        <Container>
                            <Row>
                                <Col xs="4" lg="2" ></Col>
                                <Col xs="1" lg="2">
                                    <p className="text-right">{this.state.gameInfo.Round}/{this.state.gameInfo.NumberOfRounds}</p>
                                </Col>
                                <Col xs="5" lg="6" >
                                    <p className="text-left">{this.getProgressLabel()}</p>
                                </Col>
                                <Col xs="2" lg="2"></Col>
                            </Row>
                            <Row>
                                <Col xs="12">
                                    <Progress color={this.getProgressColorFor(progress)} value={progress}></Progress>
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
                {this.renderTasksSelectionButton()}
                {tasks}
                {this.renderTasksSelectionButton()}
            </Container>

        );
    }

    renderTasksSelectionButton() {
        return (
            <Row className="space-top space-bottom">
                <Col className="hidden-md"></Col>
                <Col lg="6">
                    <Button color="primary" block tag={Link} to="/play/game">Arbeitsbereich wechseln</Button>
                </Col>
                <Col className="hidden-md"></Col>
            </Row>
            );
    }

    getProgressColorFor(progress) {
        if (this.isGamePaused()) {
            return "warning";
        }
        return getProgressColorFor(progress);
    }

    getProgressLabel() {
        if (this.isGamePaused()) {
            return "pausiert";
        }
        return `${this.state.remainingDuration} Sekunden`;
    }

    
}


// WEBPACK FOOTER //
// ./src/components/Game/PlayTasks.jsx